import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Title } from '@angular/platform-browser';
import { PageHeaderComponent } from '../../layout/page-header/page-header.component';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: true,
    imports: [PageHeaderComponent]
})
export class PrivacyComponent implements OnInit {
  headerImage: string;

  constructor(breakpointObserver: BreakpointObserver, private title: Title) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.headerImage = './../../../../../assets/images/backgrounds/settings/privacy_header_mobile.jpg';
      } else {
        this.headerImage = './../../../../../assets/images/backgrounds/settings/privacy_header_desktop.jpg';
      }
    });
  }

  ngOnInit(): void {
    this.title.setTitle('Bruce\'s | Privacy Policy');
  }

}
